import { useSetAtom } from 'jotai';
import { mediaViewerAtomV2 } from '../states/media-viewer-state';
import { SimpleMediaMessageForMediaViewer } from '../typings/message-types';
import { useCallback } from 'react';

export const useMediaViewerV2 = () => {
  const mediaViewerDispatch = useSetAtom(mediaViewerAtomV2);

  const handler = useCallback(
    ({ message }: { message: SimpleMediaMessageForMediaViewer }) => {
      mediaViewerDispatch({
        isMediaViewerV2Active: true,
        messageTypes: message.messageTypes,
        activeIndex: message.activeIndex ?? 0,
        filesUrl: message.filesUrl,
        forwardPayloads: message.forwardPayloads ?? [],
      });
    },
    [mediaViewerDispatch]
  );

  return handler;
};
